import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames/bind';
import MoreDetailsModalLink from 'yoda-checkout-components/lib/components/MoreDetailsModalLink/MoreDetailsModalLink';
import {
    TRUCABLE_PRODUCT_CONSTANTS_TRUCK_DELIVERY_LABEL,
    TRUCKABLE_DELIVERY_CONTENT,
    LARGE_APP_TRUCK_DELIVERY_CONTENT,
} from 'yoda-checkout-components/lib/common/Constants';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import * as styles from './SilverItemDeliveryInformation.css';

const cx = classNames.bind(styles);
function SilverItemDeliveryInformation(props) {
    const { charge, truckableDeliveryMessage } = props;
    let price = `$${charge}`;
    let showFree = charge === undefined || charge === 0;
    if (props.isNewCheckoutRedesign) {
        price = charge;
        showFree = charge === '$0.00';
    }
    return (
        <div
            className={dt(['pt-6', 'inline-block'])}
            data-automation-id="at-silver-information-wrapper"
        >
            <span
                className={dt(['block', 'font-open-sans-semibold', 'text-black', 'text-normal'])}
                data-automation-id="at-silver-information-wrapper-title"
            >
                {TRUCABLE_PRODUCT_CONSTANTS_TRUCK_DELIVERY_LABEL}
                :&nbsp;
                {showFree && <span className={dt(['mr-1', 'text-brand-red'])}>FREE</span>}
                {!showFree && <span>{price}</span>}
            </span>
            <span
                className={dt(['text-small', 'text-black'])}
                data-automation-id="at-silver-information-wrapper-message"
            >
                {props.isSilverItem ? (
                    ''
                ) : (
                    <div className={dt(['my-1'])}>{truckableDeliveryMessage}</div>
                )}
                <span
                    className={`${cx('silverInformationLinkWrapper')} ${dt(['smMd:!leading-5'])}`}
                    data-automation-id="at-silver-information-wrapper-link"
                >
                    <MoreDetailsModalLink
                        type={
                            props.isSilverItem
                                ? LARGE_APP_TRUCK_DELIVERY_CONTENT
                                : TRUCKABLE_DELIVERY_CONTENT
                        }
                        text="See Details"
                        modalAutoId="truck-delivery-see-details"
                        linkAutoId="see-details-link-truck"
                        btnSize="Sm"
                        linkClass={dt(['sm:!text-sm', 'sm:!leading-5'])}
                        backgroundFreezeFlag
                        analyticsModalEventName="Checkout: Truck delivery details"
                    />
                </span>
            </span>
        </div>
    );
}

SilverItemDeliveryInformation.propTypes = {
    charge: PropTypes.objectOf(PropTypes.object).isRequired,
    isSilverItem: PropTypes.bool,
    isNewCheckoutRedesign: PropTypes.bool,
    truckableDeliveryMessage: PropTypes.string,
};

SilverItemDeliveryInformation.defaultProps = {
    isSilverItem: false,
    isNewCheckoutRedesign: false,
    truckableDeliveryMessage: '',
};

export default SilverItemDeliveryInformation;
